import baseStreamSaga from './base/sagas';
export default [baseStreamSaga];
//# sourceMappingURL=sagas.js.map